var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSocialLinkTelegram = function SvgSocialLinkTelegram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 62 78"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M45.2 1H16.8C8.074 1 1 8.074 1 16.8v28.4C1 53.926 8.074 61 16.8 61h3.098v9.136c0 1.284 1.076 2.326 2.362 2.326s2.362-1.042 2.362-2.326v-5.358c0-.9.754-1.632 1.658-1.632s1.612.73 1.612 1.632l-.03 8.478v.024c0 1.286 1.078 2.328 2.362 2.328s2.362-1.04 2.362-2.328v-9.856a1.629 1.629 0 1 1 3.256 0l-.016 1.236v9.166c0 1.284 1.01 2.326 2.296 2.326s2.294-1.042 2.294-2.326V62.608c0-.808.63-1.478 1.408-1.608H45.2C53.926 61 61 53.926 61 45.2V16.8C61 8.074 53.926 1 45.2 1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#social-link-telegram_svg__a)",
    d: "M14.484 29.76s14.948-6.134 20.132-8.294c1.988-.864 8.726-3.628 8.726-3.628s3.11-1.21 2.852 1.728c-.086 1.21-.778 5.444-1.468 10.022-1.036 6.48-2.16 13.566-2.16 13.566s-.172 1.988-1.642 2.334c-1.468.346-3.888-1.21-4.32-1.556-.346-.26-6.48-4.148-8.726-6.048-.604-.518-1.296-1.556.086-2.764 3.11-2.852 6.826-6.394 9.072-8.64 1.036-1.036 2.074-3.456-2.246-.518-6.134 4.234-12.182 8.208-12.182 8.208s-1.382.864-3.974.086a182 182 0 0 1-5.616-1.814s-2.074-1.296 1.468-2.678z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "social-link-telegram_svg__a",
    x1: 29.31,
    x2: 29.31,
    y1: 19.734,
    y2: 47.342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15A29"
  })))));
};
export default SvgSocialLinkTelegram;